<template>
    <div>
        <router-link :to="{ hash: '#mobileapps' }" @click.native="$moveToAnchor('#mobileapps')">
            <article class="message" :class="{ 'transition-up move-up-on-hover': !this.isMobile && !this.isTablet }">
                <div class="message-header message-header-color-3 is-size-5-custom message-header-center has-text-centered" :class="{ 'min-text-height-message': !this.isTablet, 'min-text-height-message-custom-tablet': this.isTablet }">
                    <p>
                        {{ $t('kmso.software_development.main_box_2_title') }}
                    </p>
                </div>
                <div class="message-body is-size-5-custom">
                    <figure class="image is-3by2">
                        <img src="/img/mobileapp.svg" :alt="$t('kmso.software_development.main_box_2_title')">
                    </figure>
                </div>
                <div class="message-footer message-header-color-3 is-size-5-custom">
                    <div class="is-vertical-center add-horizontal-center message-min-text-footer-height">
                        <p class="link-text">
                            {{ $t('kmso.general.learn_more') }}
                        </p>
                    </div>
                </div>
            </article>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'Software-1',
        props: [
            'isMobile',
            'isTablet',
        ],
    }
</script>
